import type { ApiInfo } from '@meego-remote/core/app/service'
import { newApiMap } from './.newApiMap.gen'
import type { ISettingApiService } from './bam-auto-gen/interface/SettingApi'

type ApiServiceParser<T> = {
  [K in keyof T]: {
    req: (T[K] extends (req: infer Req) => void ? Req : never) & {};
    /** 原本 IDL 自动生成 interface 保证了此处返回一定有 Promise<> */
    res: (T[K] extends (...args: any[]) => Promise<infer Res> ? Promise<Res> : never) & {};
  }
}

export type ApiServiceReqRes = ApiServiceParser<ISettingApiService>

export const apiMap = newApiMap as Record<string, ApiInfo>

export type RPC = keyof ISettingApiService
export const RPC: {
  [K in keyof ISettingApiService]: K
} = Object.fromEntries(Object.entries(newApiMap).map(([key]) => [key, key])) as any
